import {Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { UserManagementService } from '../user-management/user-management.service';
import { DataShareService } from '../service/data-share.service';
import { Observable, Subscription } from 'rxjs';
import { Links } from '../models/report.model';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NotificationsService } from '../notifications/notifications.service';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-executive-nav',
    templateUrl: './executive-nav.component.html',
    styleUrls: ['./executive-nav.component.css'],
    standalone: false
})
export class ExecutiveNavComponent implements OnInit, OnDestroy, AfterViewInit {
  public isCollapsed = false;
  public isMenuCollapsed = true;
  public selectedSite = '';
  public sitesList: any[] = [];
  public siteinfo:any = [];
  ch_pass : any;
  labSidebardisplay: boolean;
  changePasswordShow: boolean;

  showLinks = false;
  
  public links$: Observable<Links[]>;
  @ViewChild('notificationListComponent') notificationListComponent: any;
  unreadNotificationCount = 0;
  isNotificationPanelOpen = false;
  private subscriptions: Subscription[] = [];
  avatarUrl: string = './assets/images/avathar.jpg';
  imageSrc: SafeUrl | string = this.avatarUrl;
  public user: any;
  visitedUserManagementSites = false;
  
  constructor(private userService: UserManagementService, private datashareSvc: DataShareService, 
    private router: Router, private notificationService: NotificationsService,
    private http: HttpClient, private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.user = this.userService.getUserDetail();
    
    // Check if user came from user-management-sites (admin role 16)
    this.visitedUserManagementSites = sessionStorage.getItem('visitedUserManagementSites') === 'true';
    
    if (this.user?.id || this.user?.user_id) {
      this.loadUserImage(this.user.id || this.user.user_id);
    } else {
      this.imageSrc = this.avatarUrl;
    }

    this.router.events.pipe(
      // filter((event) => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      if(this.router.url !== '/report-system/view-dashboard/0?type=executive'){
        let routArr=this.router.url.split('/')
        if(routArr[1]=='slideshow'){
          this.showLinks = true;
        }else{
          this.showLinks = false;
        }
      }else{
      this.showLinks = true;
      }
    });

    // Handle initial URL on page load
    this.showLinks = this.router.url === '/';
    
    this.links$ = this.datashareSvc.links$$;
    
    // Subscribe to notification unread count
    const unreadSub = this.notificationService.unreadCount$.subscribe(
      (count) => {
        this.unreadNotificationCount = count;
        // Trigger change detection to avoid ExpressionChangedAfterItHasBeenCheckedError
        this.cdr.detectChanges();
      }
    );
    this.subscriptions.push(unreadSub);
  }
  
  ngAfterViewInit(): void {
    // Ensure ViewChild is initialized
    if (this.notificationListComponent) {
      this.cdr.detectChanges();
    }
  }
  
  loadUserImage(userId: string | number): void {
    if (!userId) {
      this.imageSrc = this.avatarUrl;
      return;
    }
    const imageUrl = `${environment.nodeUrl1}user-image/${userId}?t=${Date.now()}`;
    this.http.get(imageUrl, { responseType: 'blob' }).subscribe(
      (blob) => {
        this.imageSrc = this.sanitizer.bypassSecurityTrustUrl(
          URL.createObjectURL(blob)
        );
      },
      () => {
        this.imageSrc = this.avatarUrl;
      }
    );
  }
  
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  logout() {
    // Clear filter selections before logout
    this.clearAllFilterSelections();
    
    this.userService.logout();
    sessionStorage.removeItem('visitedUserManagementSites');
    sessionStorage.removeItem('admin_id');
  }

  private clearAllFilterSelections(): void {
    try {
      const allKeys = Object.keys(localStorage);
      const filterKeys = allKeys.filter(key => key.startsWith('reportFilter_'));
      
      filterKeys.forEach(key => {
        localStorage.removeItem(key);
        console.log(`✅ Executive Nav: Cleared filter selection for key: ${key}`);
      });
      
      console.log(`🎉 Executive Nav: Cleared ${filterKeys.length} filter selections`);
    } catch (e) {
      console.error('❌ Error clearing filter selections in executive-nav:', e);
    }
  }
  public onLinkClick(index: number) {
    this.datashareSvc.selectedLinkIndex$$.next(index);
    
  }
  
  toggleNotificationPanel(): void {
    this.isNotificationPanelOpen = !this.isNotificationPanelOpen;
    // Prevent body scroll when panel is open
    if (this.isNotificationPanelOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  closeNotificationPanel(): void {
    this.isNotificationPanelOpen = false;
    document.body.style.overflow = '';
  }

  onBackdropClick(event: MouseEvent): void {
    // Close panel when clicking on backdrop
    if ((event.target as HTMLElement).classList.contains('notification-backdrop')) {
      this.closeNotificationPanel();
    }
  }
  
  get isDarkMode(): boolean {
    return this.notificationListComponent?.isDarkMode ?? false;
  }
  
  onThemeToggle(): void {
    if (this.notificationListComponent) {
      this.notificationListComponent.toggleTheme();
      // Force change detection to update the UI
      this.cdr.detectChanges();
    }
  }
}
